import React, {useState, useEffect} from 'react';
import {useCookies, removeCookie} from 'react-cookie';
import './style.css';
import Admin from './components/admin';
import Nurse from './components/nurse';
import {API} from './api-service';
import Button from 'react-bootstrap/Button';
import { FadeLoader } from 'react-spinners';


function App(){
    const [admin, setAdmin] = useState(false);
    const [connected, setConnected] = useState(true);
    const [loading, setLoading] = useState(true);
    const [userID, setUserID] = useState(0);
    const [updates, setUpdates] = useState(0);
    const [inverted, setInverted] = useState(false);
    const [cases, setCases] = useState([]);
    const [token, , removeToken] = useCookies(['pn-token']);

    
    useEffect(() => {
        if (token['pn-token']) {
            API.checkUser(token['pn-token'])
            .then(resp => resp?
                (resp.status?setLoading(false) : removeToken('pn-token')):
                (console.log("No response"))
            )
            .catch(() => {console.log("Failed to connect"); setConnected(false);});
        }
        else {
            window.location.href = '/login';
        }
    }, [])

    useEffect(() => {
        if(connected){
            if (updates){
                API.listCases(token['pn-token'])
                .then(resp => {setCases(resp); setInverted(!inverted); })
            }
            else{
                API.retrieveUser(token['pn-token'])
                .then(resp => {setAdmin(resp.admin); setUserID(resp.id)})
                API.listCases(token['pn-token'])
                .then(resp => setCases(resp))
            }
        }
        
    }, [updates])

    const logoutClicked = () => {
        removeToken('pn-token');
        window.location.href = '/login';
    }

    return(
        <div className="App">
            {loading?
                <header className="App-header">
                    <span/>
                    <h1 className='App-title'>Phleb-O-Nurse</h1>
                    <span/>
                    <span/>
                    <FadeLoader cssOverride={{margin: "-20px auto"}}/>
                    <span></span>
                </header>:
                <>
                    {connected?
                        <>
                            <header className="App-header">
                                <span/>
                                <h1>Phleb-O-Nurse</h1>
                                <Button variant="light" className='switch' onClick={() => logoutClicked()}>Logout</Button>
                                <span/>
                                <>{admin? <h4>Administrator</h4>:<h4>Nurse</h4>}</>
                                <span/>
                            </header>
                            {admin?
                                <Admin cases={cases} setCases={setCases} inverted={inverted} token={token}></Admin>:
                                <Nurse cases={cases} setCases={setCases} inverted={inverted} token={token}></Nurse>
                            }
                        </>
                        :
                        <>
                            <header className="App-header">
                                <h1 className='App-title'>Phleb-O-Nurse</h1>
                            </header>
                            <p>Failed to connect to server</p>
                        </>
                    }
                </>
            }
            
        </div>
    )
}

export default App;